<template>
  <transition name="modal">
    <div class="modal ucd-modal" id="ucd-modal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h3>{{ $t('unsaved tooltip') }}</h3>
          </div>
          <div class="modal-body">
            <div v-if="busy"><p>{{ $t('saving dialog message') }}<br>{{ $t('wait dialog message') }}</p></div>
            <p v-else>{{ $t('save dialog message') }}</p>
          </div>
          <div class="modal-footer">
            <div class="modal-footer-left">
              <button id="ucd-cancel" class="modal-btn" @click="cancel" :disabled="busy">{{ $t('cancel title') }}</button>
            </div>
            <div class="modal-footer-right">
              <button id="ucd-discard" class="modal-btn" @click="discard" :disabled="busy">{{ $t('discard title') }}</button>
              <button id="ucd-save" class="modal-btn primary" @click="save" :disabled="busy">{{ $t('save title') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    busy: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    discard () {
      this.$emit('discard')
    },
    save () {
      this.$emit('save')
    }
  }
}
</script>
